import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import {MatSidenavModule} from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatTabsModule } from '@angular/material/tabs';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';

import { ThemeService } from '../services/theme.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    BrowserAnimationsModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatSortModule,
    MatDialogModule,
    MatCheckboxModule,
    MatSidenavModule,
    MatButtonModule,
    MatToolbarModule,
    MatTooltipModule,
    MatInputModule,
    MatCardModule,
    MatSnackBarModule,
    MatSlideToggleModule,
    MatMenuModule,
    MatSelectModule,
    MatChipsModule,
    MatListModule,
    MatDatepickerModule,
    MatTabsModule,
    MatRadioModule
  ],
  exports: [CommonModule,
    MatButtonModule,
    MatIconModule,
    BrowserAnimationsModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatSortModule,
    MatDialogModule,
    MatCheckboxModule,
    MatButtonModule,
    MatToolbarModule,
    MatTooltipModule,
    MatInputModule,
    MatCardModule,
    MatSnackBarModule,
    MatSlideToggleModule,
    MatMenuModule,
    MatSelectModule,
    MatChipsModule,
    MatSidenavModule,
    MatListModule,
    MatDatepickerModule,
    MatTabsModule,
    MatRadioModule
  ]
})
export class AngularMaterialModule
{


  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private themeService: ThemeService
  )
  {
    let theme = this.themeService.currentTheme
    let themeFolder = this.themeService.currentTheme.toLowerCase()

    this.matIconRegistry.addSvgIcon(
      `checkmark`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        `../assets/${ themeFolder }/icons/Checkmark${ theme }.svg`
      )
    );

    this.matIconRegistry.addSvgIcon(
      `close`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        `../assets/${ themeFolder }/icons/Close${ theme }.svg`
      )
    );

    this.matIconRegistry.addSvgIcon(
      `dash`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        `../assets/${ themeFolder }/icons/Dash${ theme }.svg`
      )
    );

    this.matIconRegistry.addSvgIcon(
      `deleteUser`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        `../assets/${ themeFolder }/icons/DeleteUser${ theme }.svg`
      )
    );

    this.matIconRegistry.addSvgIcon(
      `dropdownMenu`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        `../assets/${ themeFolder }/icons/DropdownMenu${ theme }.svg`
      )
    );

    this.matIconRegistry.addSvgIcon(
      `enterPrescription`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(
          `../assets/${ themeFolder }/icons/EnterPrescription${ theme }.svg`
      )
  );

        this.matIconRegistry.addSvgIcon(
            `logout`,
            this.domSanitizer.bypassSecurityTrustResourceUrl(//fix it
                `../assets/${ themeFolder }/icons/Logout${ theme }.svg`
            )
        );

    this.matIconRegistry.addSvgIcon(
      `pendingDelete`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        `../assets/${ themeFolder }/icons/PendingDelete${ theme }.svg`
      )
    );

    this.matIconRegistry.addSvgIcon(
      `refresh`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        `../assets/${ themeFolder }/icons/Refresh${ theme }.svg`
      )
    );

    this.matIconRegistry.addSvgIcon(
      `resetPassword`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        `../assets/${ themeFolder }/icons/ResetPassword${ theme }.svg`
      )
    );

    this.matIconRegistry.addSvgIcon(
      `search`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(//fix it
        `../assets/${ themeFolder }/icons/Search${ theme }.svg`
      )
    );
   
    this.matIconRegistry.addSvgIcon(
      `tooltip`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(//fix it
        `../assets/${ themeFolder }/icons/Tooltip${ theme }.svg`
      )
    );

    this.matIconRegistry.addSvgIcon(
      `transfer`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(//fix it
        `../assets/${ themeFolder }/icons/Transfer${ theme }.svg`
      )
    );
  }
}
